export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_08_blank.b21468b9.png";